// extracted by mini-css-extract-plugin
export var copy = "ResourcePanel-module--copy--3UFDC";
export var page404Title = "ResourcePanel-module--page404-title--MNObX";
export var resourcePanel = "ResourcePanel-module--resourcePanel--mPsVJ";